<script setup lang="ts">
const emit = defineEmits<{
	selectAll: [];
	selectNone: [];
}>();
</script>

<template>
	<div>
		<DTooltip :text="$t('policy.policy_rules.select_all_tooltip')">
			<DButton
				size="xs"
				variant="link"
				:label="$t('common.all')"
				color="neutral"
				class="text-dimmed"
				@click="emit('selectAll')"
			/>
		</DTooltip>

		<span class="text-dimmed">/</span>

		<DTooltip :text="$t('policy.policy_rules.select_none_tooltip')">
			<DButton
				size="xs"
				variant="link"
				:label="$t('common.none')"
				color="neutral"
				class="text-dimmed"
				@click="emit('selectNone')"
			/>
		</DTooltip>
	</div>
</template>
